import type { TaskInstance } from './task-instance.interface';

export interface TaskTopHousing {
    C_MaterialPool_key: number;
    C_TaskInstance_key: number;
    HousingID: string;
    TaskInstance: TaskInstance;
}
